"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toMarkdown = void 0;
const toMarkdown = (element, _context) => {
    var _a;
    if (!((_a = element.value) === null || _a === void 0 ? void 0 : _a.code)) {
        return '';
    }
    const { code, language } = element.value;
    const lang = language || '';
    return `\n\n\`\`\`${lang}\n${code}\n\`\`\`\n\n`;
};
exports.toMarkdown = toMarkdown;
